import { toast } from "../../../components/toastNotification";
import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getAllModule = async () => {
  const { data } = await axios.get(`${api_base_url}/ModuleManagement`);
  return data;
};

export const getAllUser = async () => {
  const { data } = await axios.get(
    `${api_base_url}/ModuleManagement/GetAllUser`
  );
  return data;
};

export const getUserPermission = async (userId) => {
  return await axios
    .get(`${api_base_url}/ModuleManagement/${userId}`)
    .then((res) => {
      if (res.status === 200) {
        return res.data;
      } else {
        toast.fire(
          "Warning",
          "Cannot Retrieve Permissions, please check connection or contact your admin",
          "error"
        );
        return [];
      }
    });
};

export const getUserPermissionPerField = async (userId) => {
  const { data } = await axios.get(
    `${api_base_url}/ModuleManagement/PermissionPerField/${userId}`
  );
  return data;
};

export const updateUserPermission = async (permissions) => {
  return axios
    .post(
      `${api_base_url}/ModuleManagement/UpdateUserPermissions/`,
      permissions
    )
    .then((res) => {
      if (res.status === 400) {
        res.json();
      }
      return res.permissions;
    });
};

export const updateUserRole = async (userRole) => {
  return axios
    .put(`${api_base_url}/ModuleManagement/ChangeUserRole/`, userRole)
    .then((res) => {
      if (res.status === 400) {
        res.json();
      }
      return res.userRole;
    });
};
export const deleteUsers = async (ids) => {
  await axios.delete(`${api_base_url}/ModuleManagement/DeleteUser`, {
    data: ids,
  });
};
export const deactivateRoles = async (ids) => {
  return await axios.delete(
    `${api_base_url}/ModuleManagement/DeactivateRoles`,
    {
      data: ids,
    }
  );
};
export const updateRolePermission = async (permissions) => {
  return await axios.post(
    `${api_base_url}/ModuleManagement/UpdateRolePermissions/`,
    permissions
  );
};

export const updateRoleManagement = async (newData) => {
  const res = await axios.put(
    `${api_base_url}/ModuleManagement/UpdateRoleManagement`,
    newData
  );

  return res.data;
};

export const addRole = async (roleData) => {
  return await axios.post(`${api_base_url}/ModuleManagement/AddRole`, roleData);
};
